import React from 'react';
import { boundingBox, boundingBox1400, boundingBox1280, boundingBox960, bannerWrapper, layout, layoutWrapper, footerWrapper, overviewContentWrapper, headerContent, headerActionArea, headerWrapper, heading, noPadding, searchWrapper, searchWrapperSideBar, sectionTitle, sectionTitleWrapper, sideBarWrapper, sideBarContentWrapper, filterWrapper, filterWrapperSideBar, titleWrapper, } from '../styles/legacy';
import { boundingBox as boundingBoxCitron, boundingBox1440 as boundingBox1440Citron, boundingBox1280 as boundingBox1280Citron, boundingBox960 as boundingBox960Citron, bannerWrapper as bannerWrapperCitron, content as contentCitron, layout as layoutCitron, layoutWrapper as layoutWrapperCitron, overviewWrapper as overviewWrapperCitron, overviewContentWrapper as overviewContentWrapperCitron, footerWrapper as footerWrapperCitron, headerContent as headerContentCitron, headerActionArea as headerActionAreaCitron, headerWrapper as headerWrapperCitron, heading as headingCitron, noPadding as noPaddingCitron, searchWrapper as searchWrapperCitron, searchWrapperSideBar as searchWrapperSideBarCitron, sectionTitle as sectionTitleCitron, sectionTitleWrapper as sectionTitleWrapperCitron, sideBar as sideBarCitron, sideBarWrapper as sideBarWrapperCitron, sideBarContentWrapper as sideBarContentWrapperCitron, sideBarLeftWrapper as sideBarLeftWrapperCitron, sideBarRightWrapper as sideBarRightWrapperCitron, filterWrapper as filterWrapperCitron, filterWrapperSideBar as filterWrapperSideBarCitron, titleWrapper as titleWrapperCitron, } from '../styles/citron';
import { BorderlessButton } from '@citrus/button';
import { citrusStyled } from '@citrus/runtime';
import { useTheme } from '@citrus/user';
import { css } from 'emotion';
export var Col = citrusStyled.div('N/A', null);
export var Row = citrusStyled.div('N/A', null);
export var BoundingBox = citrusStyled.div('boundingBox', { legacy: boundingBox, citrus2022: boundingBoxCitron });
export var BoundingBox1440 = citrusStyled.div('boundingBox1440', {
    legacy: boundingBox1400,
    citrus2022: boundingBox1440Citron,
});
export var BoundingBox1280 = citrusStyled.div('boundingBox1280', {
    legacy: boundingBox1280,
    citrus2022: boundingBox1280Citron,
});
export var BoundingBox960 = citrusStyled.div('boundingBox960', {
    legacy: boundingBox960,
    citrus2022: boundingBox960Citron,
});
export var FooterWrapper = citrusStyled.div('footerWrapper', {
    legacy: footerWrapper,
    citrus2022: footerWrapperCitron,
});
export var HeaderContent = citrusStyled.div('headerContent', {
    legacy: headerContent,
    citrus2022: headerContentCitron,
});
export var HeaderActionArea = citrusStyled.div('headerActionArea', {
    legacy: headerActionArea,
    citrus2022: headerActionAreaCitron,
});
export var HeaderBackButton = citrusStyled.as(BorderlessButton)('N/A', null);
export var HeaderWrapper = citrusStyled.div('headerWrapper', {
    legacy: headerWrapper,
    citrus2022: headerWrapperCitron,
});
export var Heading = citrusStyled.h1('heading', { legacy: heading, citrus2022: headingCitron });
export var Heading2 = citrusStyled.h2('heading', { legacy: heading, citrus2022: headingCitron });
export var Layout = citrusStyled.div('layout', { legacy: layout, citrus2022: layoutCitron });
export var BannerWrapper = citrusStyled.div('bannerWrapper', {
    legacy: bannerWrapper,
    citrus2022: bannerWrapperCitron,
});
export var OverviewWrapper = citrusStyled.div('overviewWrapper', {
    legacy: null,
    citrus2022: overviewWrapperCitron,
});
export var OverviewContentWrapper = citrusStyled.div('overviewContentWrapper', {
    legacy: overviewContentWrapper,
    citrus2022: overviewContentWrapperCitron,
});
export var Wrapper = citrusStyled.div('layoutWrapper', {
    legacy: layoutWrapper,
    citrus2022: layoutWrapperCitron,
});
export var Content = citrusStyled.div('content', { legacy: null, citrus2022: contentCitron });
export var SideBar = citrusStyled.div('sideBar', { legacy: null, citrus2022: sideBarCitron });
export var SideBarWrapper = citrusStyled.div('sideBarWrapper', {
    legacy: sideBarWrapper,
    citrus2022: sideBarWrapperCitron,
});
export var SideBarContentWrapper = citrusStyled.div('sideBarContentWrapper', {
    legacy: sideBarContentWrapper,
    citrus2022: sideBarContentWrapperCitron,
});
export var SideBarLeftWrapper = citrusStyled.div('sideBarLeftWrapper', {
    legacy: null,
    citrus2022: sideBarLeftWrapperCitron,
});
export var SideBarRightWrapper = citrusStyled.div('sideBarRightWrapper', {
    legacy: null,
    citrus2022: sideBarRightWrapperCitron,
});
export var SearchWrapper = citrusStyled.div('searchWrapper', {
    legacy: searchWrapper,
    citrus2022: searchWrapperCitron,
});
export var SearchWrapperSideBar = citrusStyled.div('searchWrapperSideBar', {
    legacy: searchWrapperSideBar,
    citrus2022: searchWrapperSideBarCitron,
});
export var FilterWrapper = citrusStyled.div('filterWrapper', {
    legacy: filterWrapper,
    citrus2022: filterWrapperCitron,
});
export var FilterWrapperSideBar = citrusStyled.div('filterWrapperSideBar', {
    legacy: filterWrapperSideBar,
    citrus2022: filterWrapperSideBarCitron,
});
export var LayoutNoPadding = function (_a) {
    var children = _a.children;
    var theme = useTheme();
    return React.createElement(Layout, { className: css(theme.name === 'Citron' ? noPaddingCitron : noPadding) }, children);
};
export var SectionTitleWrapper = citrusStyled.div('sectionTitleWrapper', {
    legacy: sectionTitleWrapper,
    citrus2022: sectionTitleWrapperCitron,
});
export var SectionTitleH1 = citrusStyled.h1('sectionTitle', {
    legacy: sectionTitle,
    citrus2022: sectionTitleCitron,
});
export var SectionTitleH2 = citrusStyled.h2('sectionTitle', {
    legacy: sectionTitle,
    citrus2022: sectionTitleCitron,
});
export var SectionTitleH3 = citrusStyled.h3('sectionTitle', {
    legacy: sectionTitle,
    citrus2022: sectionTitleCitron,
});
export var SectionTitleActionArea = citrusStyled.div('N/A', null);
export var TitleWrapper = citrusStyled.div('titleWrapper', {
    legacy: titleWrapper,
    citrus2022: titleWrapperCitron,
});
export var Styled = {
    BannerWrapper: BannerWrapper,
    BoundingBox: BoundingBox,
    BoundingBox1440: BoundingBox1440,
    BoundingBox1280: BoundingBox1280,
    BoundingBox960: BoundingBox960,
    Col: Col,
    Content: Content,
    FooterWrapper: FooterWrapper,
    HeaderContent: HeaderContent,
    HeaderActionArea: HeaderActionArea,
    HeaderBackButton: HeaderBackButton,
    HeaderWrapper: HeaderWrapper,
    Heading: Heading,
    Layout: Layout,
    LayoutNoPadding: LayoutNoPadding,
    OverviewWrapper: OverviewWrapper,
    Row: Row,
    SearchWrapper: SearchWrapper,
    SearchWrapperSideBar: SearchWrapperSideBar,
    FilterWrapper: FilterWrapper,
    FilterWrapperSideBar: FilterWrapperSideBar,
    SectionTitleH1: SectionTitleH1,
    SectionTitleH2: SectionTitleH2,
    SectionTitleH3: SectionTitleH3,
    SideBar: SideBar,
    TitleWrapper: TitleWrapper,
    Wrapper: Wrapper,
};
